import { API_ENDPOINTS } from "./apiEndpoints";
import {
  PARTICIPANT_ATTENDANCE_TYPES,
  ATTENDANCE_STATUS,
} from "./attendanceTypes";
import { LABELS } from "./labels";
import { MESSAGES } from "./messages";
import { FILTERS } from "./filterConfig";
import {
  DEFAULT_PAGINATION,
  MIN_SEARCH_LENGTH,
  FIELDS,
  ATTENDANCE_THRESHOLDS,
  NUMERIC,
  WIDTHS,
  LAYOUT,
  FIELDS_ALIGNMENT_SPACE_BETWEEN,
  FOOTER_VARIANT_SECONDARY,
  TAB_VALUES,
  QUERY_CACHE_TIME_MS,
} from "./config";

export const ZOOM_ATTENDANCE_CONSTANTS = {
  API_ENDPOINTS,
  PARTICIPANT_ATTENDANCE_TYPES,
  ATTENDANCE_STATUS,
  DEFAULT_PAGINATION,
  LABELS,
  MESSAGES,
  MIN_SEARCH_LENGTH,
  FIELDS,
  ATTENDANCE_THRESHOLDS,
  NUMERIC,
  WIDTHS,
  LAYOUT,
  FIELDS_ALIGNMENT_SPACE_BETWEEN,
  FOOTER_VARIANT_SECONDARY,
  TAB_VALUES,
  QUERY_CACHE_TIME_MS,
  FILTERS,
};
